"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultsReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var SearchAction_1 = require("@/pages/search/actions/SearchAction");
exports.resultsReducer = function (state, action) {
    if (state === void 0) { state = ResultPageState_init_1.defaultResultPageState; }
    var getNewItemIsSaveState = function (id, isSave, state) {
        if (state.resultResponses.length === 0)
            return state;
        var newResultResponses = state.resultResponses.map(function (it) {
            var filterResult = it.results.filter(function (rit) { return Number(rit.referenceId) === Number(id); });
            if (!filterResult.length)
                return it;
            var indexOfMatchedItem = it.results.indexOf(filterResult[0]);
            var newResults = it.results.map(function (rit, index) {
                if (index !== indexOfMatchedItem)
                    return rit;
                return __assign(__assign({}, rit), { isSaved: isSave });
            });
            var newResponse = __assign(__assign({}, it), { results: newResults });
            return newResponse;
        });
        return __assign(__assign({}, state), { resultResponses: newResultResponses });
    };
    var getNewItemIsSavingState = function (id, isSaving, state) {
        if (state.resultResponses.length === 0)
            return state;
        var newResultResponses = state.resultResponses.map(function (it) {
            var filterResult = it.results.filter(function (rit) { return Number(rit.referenceId) === Number(id); });
            if (!filterResult.length)
                return it;
            var indexOfMatchedItem = it.results.indexOf(filterResult[0]);
            var newResults = it.results.map(function (rit, index) {
                if (index !== indexOfMatchedItem)
                    return rit;
                return __assign(__assign({}, rit), { isSaving: isSaving });
            });
            var newResponse = __assign(__assign({}, it), { results: newResults });
            return newResponse;
        });
        return __assign(__assign({}, state), { resultResponses: newResultResponses });
    };
    switch (action.type) {
        case typesafe_actions_1.getType(ResultAction_1.default.setResultPage): {
            var newResultPage = {
                page: action.payload.page,
                pageTotal: action.payload.pageTotal,
                results: action.payload.results,
                sliderInit: false,
                heading: '',
            };
            var newResultReponses = action.payload.page <= 1 ?
                [newResultPage] : __spreadArrays(state.resultResponses, [newResultPage]);
            return __assign(__assign({}, state), { resultResponses: newResultReponses });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setResultEstatePhase): {
            if (!action.payload) {
                return __assign(__assign({}, state), { estateName: '' });
            }
            return __assign(__assign({}, state), action.payload);
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setLastItemPosition): {
            return __assign(__assign({}, state), { lastItemPosition: action.payload });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setLoading): {
            return __assign(__assign({}, state), { isLoading: action.payload });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setInfiniteLoadEnable): {
            return __assign(__assign({}, state), { isInfiniteLoadEnabled: action.payload });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setSliderInited): {
            var newResultReponses = __spreadArrays(state.resultResponses);
            newResultReponses[newResultReponses.length - 1].sliderInit = true;
            return __assign(__assign({}, state), { resultResponses: newResultReponses });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.onResultChangeView): {
            return __assign(__assign({}, state), { view: action.payload });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setIsSaved): {
            return getNewItemIsSaveState(action.payload.id, action.payload.state, state);
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setItemIsSaving): {
            return getNewItemIsSavingState(action.payload.id, action.payload.state, state);
        }
        case typesafe_actions_1.getType(ResultAction_1.default.onSaveSearchClose): {
            var newResultResponses = state.resultResponses.map(function (it) {
                return __assign(__assign({}, it), { showSaveSearchPrompt: false });
            });
            return __assign(__assign({}, state), { resultResponses: newResultResponses });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.showSaveSearchPrompt): {
            var newResultResponses = state.resultResponses.map(function (it) {
                if (it.page !== action.payload)
                    return it;
                return __assign(__assign({}, it), { showSaveSearchPrompt: true });
            });
            return __assign(__assign({}, state), { resultResponses: newResultResponses });
        }
        case typesafe_actions_1.getType(SearchAction_1.default.clearTextImages): {
            return __assign(__assign({}, state), { textImages: null });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.onCloseNoResultDialog): {
            return __assign(__assign({}, state), { noResultDialogHide: true });
        }
        case typesafe_actions_1.getType(ResultAction_1.default.setIsMap): {
            return __assign(__assign({}, state), { isMap: action.payload });
        }
    }
    return state;
};
